var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative"},[_c('div',{staticClass:"absolute"},[_vm._v(_vm._s(_vm.status))]),_c('SelectBox',{attrs:{"name":_vm.name,"listData":_vm.listData,"after_zindex":true},on:{"change":_vm.change,"click":_vm.click}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }